import { isSetSupported } from "@/office/requirements";

/**
 * Verfügbarkeit einzelner Office.js-Schnittstellen für PowerPoint.
 *
 * Das Manifest verlangt für PowerPoint nur den Anforderungssatz 1.3 – damit
 * lassen sich Folien, Layouts, Folienmaster und die Formen einer Folie lesen.
 * Alles darüber hinaus ist erst in neueren PowerPoint-Versionen vorhanden und
 * wird deshalb zur Laufzeit abgefragt, statt Nutzer über eine hohe
 * Mindestanforderung auszusperren.
 *
 * Anders als bei Word gibt es hier keinen eigenen Desktop-Anforderungssatz:
 * PowerPoint im Web und PowerPoint für Windows unterscheiden sich nur über die
 * Versionsnummer von "PowerPointApi".
 */

/** Anforderungssätze, die in den Kursen geprüft werden. */
export const powerPointApi = {
  /** Foliensammlung der Präsentation. */
  slides: "1.2",
  /** Formen einer Folie, zugewiesenes Layout, Folienmaster, Tags. */
  shapes: "1.3",
  /**
   * Name, Typ, Position und Größe einer Form sowie ihr Textrahmen mit
   * Schriftart, Größe, Ausrichtung und Aufzählungszeichen.
   */
  shapeDetails: "1.4",
  /** Dokumenteigenschaften: Titel, Autor, Firma. */
  documentProperties: "1.7",
  /** Platzhalterart einer Form – die Grundlage des ganzen Kurses. */
  placeholders: "1.8",
  /** Art des zugewiesenen Folienlayouts (Titelfolie, Abschnittsüberschrift, …). */
  layoutType: "1.8",
  /** Inhalt einer Tabelle auf einer Folie. */
  tables: "1.8",
  /** Alternativtext und Kennzeichnung als dekorativ. */
  altText: "1.10",
  /** Folienhintergrund und Farben des Designs. */
  design: "1.10",
  /** Gliederungsebene eines Absatzes im Textrahmen. */
  indentLevel: "1.10",
} as const;

export function supportsPowerPointApi(version: string): boolean {
  return isSetSupported("PowerPointApi", version);
}
